export default __webpack_public_path__ + "images/traverse_blue.685b4f33aeb9b41b24c1ea182f56920b.png";